import { useEffect } from 'react';

const SITE_NAME = 'Atlas Academy';
const SITE_URL = 'https://www.atlas-academy.co.uk';
const DEFAULT_DESCRIPTION =
  'Flexible online courses from Atlas Academy. Study at your own pace with accredited UK qualifications from OTHM and QUALIFI.';

function setMeta(attr, key, content) {
  let tag = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!tag) {
    tag = document.createElement('meta');
    tag.setAttribute(attr, key);
    document.head.appendChild(tag);
  }
  tag.setAttribute('content', content);
}

function setCanonical(href) {
  let link = document.head.querySelector('link[rel="canonical"]');
  if (!link) {
    link = document.createElement('link');
    link.setAttribute('rel', 'canonical');
    document.head.appendChild(link);
  }
  link.setAttribute('href', href);
}

// Per-page document title, meta description, Open Graph tags, canonical URL,
// and optional JSON-LD structured data. Render once per page.
export default function Seo({ title, description = DEFAULT_DESCRIPTION, path = '', jsonLd = null }) {
  // Serialize so inline jsonLd objects don't re-trigger the effect every render
  const jsonLdString = jsonLd ? JSON.stringify(jsonLd) : null;

  useEffect(() => {
    const fullTitle = title ? `${title} | ${SITE_NAME}` : `${SITE_NAME} – Accredited Online Courses & UK Qualifications`;
    const url = `${SITE_URL}${path}`;

    document.title = fullTitle;
    setMeta('name', 'description', description);
    setMeta('property', 'og:title', fullTitle);
    setMeta('property', 'og:description', description);
    setMeta('property', 'og:url', url);
    setMeta('name', 'twitter:title', fullTitle);
    setMeta('name', 'twitter:description', description);
    setCanonical(url);

    let script;
    if (jsonLdString) {
      script = document.createElement('script');
      script.type = 'application/ld+json';
      script.text = jsonLdString;
      document.head.appendChild(script);
    }
    return () => {
      if (script) document.head.removeChild(script);
    };
  }, [title, description, path, jsonLdString]);

  return null;
}
